const KlaviyoScript = () => {
  return (
    <script
      async
      type="text/javascript"
      src="//static.klaviyo.com/onsite/js/klaviyo.js?company_id=XcrkeD"
    />
  );
};

export default KlaviyoScript;
